import React from "react";
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import { useState, useEffect } from "react";
import MCQQuestion from "../../QuestionPage/Mcq";

// Fetching Data from the API]

// End

// Page Html
export default function MultipleTypeSingleMockPage({ question,onInputChange ,questionNumber }) {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };
  const mockData = question;

  const [originalWords, setOriginalWords] = useState("");
  const [McqOptions, setMcqOptions] = useState("");
  const [Mcq_Question, setMcq_Question] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isAttempted, setIsAttempted] = useState(false);

  // const [originalWords, setOriginalWords] = useState("");

  // const originalWords = mockData.question;

  useEffect(() => {
    // Set the state when the question prop changes
    setOriginalWords(question.question);
    setMcqOptions(question.option);
    setMcq_Question(question.question_mcq);
  }, [question]);

  const handleRetake = () => {
    setSelectedOption(null);
    setSubmitted(false);
    setIsAttempted(false);
  };

  const handleOptionSelect = (selectedOption) => {
    setSelectedOption(selectedOption);
    onInputChange(selectedOption);

  };

  useEffect(() => {
    console.log("Selected Options ", selectedOption);
  }, [selectedOption]);

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of 16
        </h2>
        <p className="p-2">
        You will hear a sentence. Please repeat the sentence exactly as you hear it. You will hear the sentence only once.
        </p>

        <QuestionBox question={originalWords}/>
        {/* <div className="font-bold p-2 pt-4 ml-[1000px] ">Time left:9.22 </div> */}
        <MCQQuestion
          question={Mcq_Question}
          options={McqOptions}
          onOptionSelect={handleOptionSelect}
          selectedOption={selectedOption}
          submitted={submitted}
        />

      </div>
    </div>
  );
}
